<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      label-width="85px"
      label-position="left"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <div class="el-form-row">
        <el-form-item :label="$l('form_label_operatorBy') || '操作人'">
          <el-input v-model="formData.createByName" readonly />
        </el-form-item>
        <el-form-item :label="$l('form_label_operatorTime') || '操作时间'">
          <el-input v-model="formData.createTime" readonly />
        </el-form-item>
      </div>
      <div class="el-form-row">
        <el-form-item
          :label="
            formData.changeType == 'D'
              ? $l('form_label_deleteRemark') || '删除原因'
              : $l('form_label_updateRemark') || '修改原因'
          "
          prop="remark"
        >
          <el-input
            v-model="formData.remark"
            v-if="!disabled"
            :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
            type="textarea"
            :rows="5"
            :maxlength="200"
            show-word-limit
            clearable
          />
          <el-input v-model="formData.remark" v-else readonly />
        </el-form-item>
      </div>
      <div v-if="formData.changeType == 'U'">
        <div
          v-for="field in formData.fieldList"
          :key="field.fieldName"
          class="mt-4"
        >
          <div class="el-form-row">
            <el-form-item :label="$l('form_label_fieldName') || '变更字段'">
              <el-input :value="fieldTitle[field.fieldName]" readonly />
            </el-form-item>
            <el-form-item
              :label="$l('form_label_fieldOldValue') || '变更前数据'"
              label-width="90px"
            >
              <el-input v-model="field.fieldOldValue" readonly />
            </el-form-item>
            <el-form-item
              :label="$l('form_label_fieldNewValue') || '变更后数据'"
              label-width="90px"
            >
              <el-input v-model="field.fieldNewValue" readonly />
            </el-form-item>
          </div>
          <div class="el-form-row">
            <el-form-item :label="$l('form_label_updateRemark') || '修改原因'">
              <el-input
                v-model="field.remark"
                v-if="!disabled"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                type="textarea"
                :rows="3"
                :maxlength="150"
                show-word-limit
                clearable
              />
              <el-input v-model="field.remark" v-else readonly />
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import dayjs from 'dayjs'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    amzPurchaseChangeCode: { type: String, default: '' },
    amzPurchaseDetailCode: { type: String, default: '' },
    changeType: { type: String, default: '' },
    changeFields: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: { createByName: '', createTime: '', remark: '', fieldList: [] },
    }
  },
  computed: {
    ...mapState('admin/user', { userInfo: 'info' }),
    fieldTitle() {
      return {
        inCtnQty: this.$l('table_label_inCtnQty'),
        purchaseQty: this.$l('table_label_purchaseQty'),
        purchasePrice: this.$l('table_label_purchasePrice'),
        actualDeliveryDate: this.$l('table_label_actualDeliveryDate'),
      }
    },
    rules() {
      return {
        remark: [
          {
            required: !this.disabled,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.disabled) return this.getData()

      const { userName, userNameEn } = this.userInfo
      const createByName = [userNameEn, userName].filter(Boolean).join('-')
      this.formData.createByName = createByName
      this.formData.createTime = dayjs().format('YYYY-MM-DD HH:mm:ss')
      this.formData.changeType = this.changeType

      if (this.changeType == 'U') {
        this.formData.fieldList = this.changeFields
        return
      }
    },
    async getData() {
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailChangeRecordApi({
          amzPurchaseChangeCode: this.amzPurchaseChangeCode,
          amzPurchaseDetailCode: this.amzPurchaseDetailCode,
        })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      if (this.formData.changeType == 'U') {
        await this.updateChange()
      } else if (this.formData.changeType == 'D') {
        await this.deleteChange()
      }
      this.close()
    },
    async updateChange() {
      const fields = this.formData.fieldList.map((field) => {
        const { fieldNewValue, ...item } = field
        return { ...item, fieldValue: fieldNewValue }
      })

      const params = {
        ...this.formData,
        fields,
        amzPurchaseChangeCode: this.amzPurchaseChangeCode,
        amzPurchaseDetailCode: this.amzPurchaseDetailCode,
      }

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailChangeApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status, msg } = res
      if (status !== 200) {
        this.$message.error(msg)
        return
      }

      this.$message({
        showClose: true,
        message: res.msg,
        type: 'success',
      })
    },
    async deleteChange() {
      const params = {
        ...this.formData,
        amzPurchaseChangeCode: this.amzPurchaseChangeCode,
        amzPurchaseDetailCode: this.amzPurchaseDetailCode,
      }

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzFtyPurchaseDetailDelChangeApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }

      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
    },
    cancel() {
      if (this.disabled) return this.close()
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.rejected()
        })
        .catch((action) => {
          if (action === 'cancel') this.close()
        })
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
  .border-bottom-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-bottom: none !important;
    }
  }

  .el-form .el-form-row {
    display: flex;
    border: 1px solid #ebeef5;
    border-left: none;
    .el-form-item {
      margin: 0 !important;
      position: relative;
      width: 100%;

      .el-form-item__label {
        color: #909399;
        background: #fafafa;
        box-sizing: border-box;
        text-align: left;
        font-weight: 400;
        line-height: 1.5;
        padding: 8px 10px;
        border-left: 1px solid #ebeef5;
        border-right: 1px solid #ebeef5;
        font-size: 12px !important;
        position: absolute;
        bottom: 0;
        top: 0;
      }

      .el-form-item__content {
        padding: 0 5px;
        box-sizing: border-box;
        text-align: left;
        font-weight: 400;
        line-height: 1.5;
        color: #606266;
        font-size: 12px !important;
        > div {
          margin: 3.2px 0;
        }
        > .el-input {
          input[readonly] {
            border: none;
            background-color: #fff;
            color: #606266;
            cursor: auto;
          }
        }
        .el-input-number .el-input__inner {
          text-align: left;
        }
        .no-error {
          .el-input__inner {
            border-color: #dcdfe6 !important;
          }
        }
      }
    }
  }

  .el-form .el-form-row:not(:first-child) {
    border-top: none;
  }
}
</style>
